// Drag and Drop item types
export const ItemTypes = {
  POSITION: "position",
};

// Initial form states
export const INITIAL_MATCH_FORM = { name: "", category: "" };

export const INITIAL_GROUP_FORM = {
  name: "",
  numGroups: 1,
  teamsPerGroup: 4,
  category: "",
  timesToFaceEachOther: 1
};

export const INITIAL_BRACKET_FORM = {
  name: "",
  teamsCount: 2,
  numberOfLegs: 1
};

export const INITIAL_SECTION_FORM = { name: "" };

export const INITIAL_BRACKET_GROUP_FORM = {
  name: "",
  numGroups: 1,
  teamsPerGroup: 4
};

export const INITIAL_BRACKET_MATCH_FORM = { name: "" };

export const INITIAL_RULE_FORM = {
  sourceBlockId: "",
  targetBlockId: "",
  targetPhaseId: "",
  sourcePosition: 1,
  targetTeamSlot: 1,
};

export const INITIAL_EXECUTE_RULES_DATA = {
  category: "",
  blockId: "",
};

// Template-specific initial form states
export const INITIAL_KNOCKOUT_CONFIG = {
  bracketName: "Main Bracket",
  teamsCount: 8,
  numberOfLegs: 1,
};

export const INITIAL_GROUP_CONFIG = {
  groupNamePrefix: "Group ",
  numGroups: 2,
  teamsPerGroup: 4,
  timesToFaceEachOther: 1,
  fixtureMode: "ROUND_ROBIN",
  matchesPerTeam: 1,
};

export const INITIAL_PHASE2_SETTINGS = {
  inheritSettings: false,
  name: "Knockout stage",
};

// Helper function
export const toTitleCase = (str) => {
  if (!str) return "";
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
